import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon, ArrowUpRightIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const LOGO = 'https://cdn.magicpatterns.com/uploads/wKqEAKYvkk2CFafFXdcgvT/436440C4-25F6-4554-B1BF-42E22CBC6005.png';
const MENU_LINKS = [{
  label: 'What We Do',
  href: '/#tiles'
}, {
  label: 'Vision',
  href: '/#manifesto'
}, {
  label: 'Contact Us',
  href: '/contact'
}];
const SOCIALS = ['Instagram', 'TikTok', 'X', 'YouTube'];
export function Navbar() {
  const [open, setOpen] = useState(false);
  // lock scroll while the overlay menu is open
  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);
  return <>
      <header className="fixed inset-x-0 top-0 z-50 flex justify-center px-3 pt-4 sm:pt-6" data-id="element-162">
        {/* Compact floating glass pill — logo left, menu right */}
        <nav className="flex h-14 w-full max-w-md items-center justify-between gap-8 rounded-full border border-white/15 bg-white/10 py-2 pl-6 pr-3 shadow-[0_8px_32px_rgba(0,0,0,0.35)] backdrop-blur-xl" data-id="element-163">
          <a href="/" aria-label="Aenigma home" className="flex shrink-0 items-center" data-id="element-164">
            <img src={LOGO} alt="Aenigma" className="h-16 w-auto select-none object-contain" draggable={false} data-id="element-165" />
          </a>

          <button type="button" aria-label="Open menu" aria-expanded={open} onClick={() => setOpen(true)} className="flex items-center gap-3 text-white" data-id="element-166">
            <span className="text-xs font-medium uppercase tracking-[0.25em] text-white/80" data-id="element-167">
              Menu
            </span>
            <span className="flex h-9 w-9 items-center justify-center rounded-full transition-colors hover:bg-white/10" data-id="element-168">
              <MenuIcon className="h-5 w-5" data-id="element-169" />
            </span>
          </button>
        </nav>
      </header>

      {/* Full-screen overlay menu */}
      <AnimatePresence data-id="element-170">
        {open && <motion.div className="fixed inset-0 z-[60] flex flex-col bg-black/95 backdrop-blur-2xl" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.35
      }} data-id="element-171">
            {/* faint chromatic glow behind the menu */}
            <div aria-hidden="true" className="pointer-events-none absolute left-1/2 top-1/2 h-[70vh] w-[90vw] -translate-x-1/2 -translate-y-1/2 rounded-full" style={{
          background: 'radial-gradient(ellipse at center, rgba(90,150,255,0.12) 0%, rgba(255,140,60,0.06) 40%, rgba(0,0,0,0) 72%)',
          filter: 'blur(40px)'
        }} data-id="element-172" />

            <div className="relative flex items-center justify-between px-5 pt-6 sm:px-8 lg:px-12" data-id="element-173">
              <img src={LOGO} alt="Aenigma" className="h-14 w-auto select-none object-contain sm:h-16" draggable={false} data-id="element-174" />
              <button type="button" aria-label="Close menu" onClick={() => setOpen(false)} className="flex h-11 w-11 items-center justify-center rounded-full border border-white/15 text-white transition-colors hover:border-white/40 hover:bg-white/5" data-id="element-175">
                <XIcon className="h-5 w-5" data-id="element-176" />
              </button>
            </div>

            <nav className="relative flex flex-1 flex-col justify-center px-5 sm:px-8 lg:px-12" data-id="element-177">
              <ul className="flex flex-col" data-id="element-178">
                {MENU_LINKS.map((l, i) => <motion.li key={l.label} initial={{
              opacity: 0,
              y: 30
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: 0.15 + i * 0.07,
              duration: 0.5,
              ease: [0.22, 1, 0.36, 1]
            }} data-id="element-179">
                    <a href={l.href} onClick={() => setOpen(false)} className="group flex items-center justify-between border-b border-white/10 py-4 sm:py-6" data-id="element-180">
                      <span className="font-display text-5xl uppercase leading-none tracking-tight text-white/70 transition-all duration-300 group-hover:text-chromatic sm:text-7xl md:text-8xl" data-id="element-181">
                        {l.label}
                      </span>
                      <ArrowUpRightIcon className="h-7 w-7 text-white/30 transition-all duration-300 group-hover:translate-x-1 group-hover:-translate-y-1 group-hover:text-white sm:h-10 sm:w-10" data-id="element-182" />
                    </a>
                  </motion.li>)}
              </ul>
            </nav>

            <motion.div className="relative flex flex-col gap-4 px-5 pb-8 sm:flex-row sm:items-center sm:justify-between sm:px-8 lg:px-12" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.5,
          duration: 0.5
        }} data-id="element-183">
              <div className="flex flex-wrap gap-x-6 gap-y-2" data-id="element-184">
                {SOCIALS.map(s => <a key={s} href="#top" onClick={() => setOpen(false)} className="text-xs font-medium uppercase tracking-[0.22em] text-white/50 transition-colors hover:text-white" data-id="element-185">
                    {s}
                  </a>)}
              </div>
              <a href="/contact" onClick={() => setOpen(false)} className="text-xs font-medium uppercase tracking-[0.22em] text-white/50 transition-colors hover:text-white" data-id="element-186">
                hello@aenigma.co
              </a>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}